import { GoodHealthForm } from "Pages/GoodHealthForm";
import { PolicyDraft } from "Pages/PolicySaveDraft";
import { PolicySummary } from "Pages/PolicySummary";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { Home } from "./Pages/Home";
import { InsurancePolicies } from "./Pages/InsurancePolicies";
import { Lifestyle } from "./Pages/Lifestyle";
import { MemberDetails } from "./Pages/MemberDetails";
import { Payment } from "./Pages/Payment";
import { Plans } from "./Pages/Plans";
import { PreExistingDisease } from "./Pages/PreExistingDiseases";
import SSOLogin from "./Pages/SSOLogin";

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/ssotoken/:token" element={<SSOLogin />} />
      <Route path="" element={<Home />} />
      {/* <Route path="/insurance-policy" element={<InsurancePolicies />} />
      <Route path="/member-details" element={<MemberDetails />} />
      <Route path="/lifestyle" element={<Lifestyle showQuestions={false} />} /> */}
      {/* <Route path="/lifestyle-questions" element={<Lifestyle showQuestions={true} />} /> */}

      {/* <Route path="/plans" element={<Plans />} /> */}
      {/* <Route
        path="/pre-existing-diseases"
        element={<PreExistingDisease showQuestions={false} />}
      />
      <Route
        path="/pre-existing-diseases-details"
        element={<PreExistingDisease showQuestions={true} />}
      /> */}
      {/* <Route
        path="/payment"
        element={
          <Payment
            includedMembersArray={[
              "spouse",
              "daughter",
              "son",
              "self",
              "father-in-law",
              "mother-in-law",
              "father",
              "mother",
            ]}
            policyNumber="1"
          />
        }
      />
      <Route path="/good-health-declaration" element={<GoodHealthForm/>} />
      <Route path="/policy-summary" element={<PolicySummary />} />
      <Route path="/policy-draft/:userID" element={<PolicyDraft />} /> */}
    </Routes>
  );
};
